module.exports = new __parcel__URL__("gallery_7.e5bb4829.jpg").toString();